import { cn } from "../../lib/utils";

type PerformanceBarProps = {
  value: number;
  max?: number;
  className?: string;
  showLabel?: boolean;
};

export function PerformanceBar({
  value,
  max = 100,
  className,
  showLabel = true,
}: PerformanceBarProps) {
  const percentage = Math.min(100, Math.max(0, (value / max) * 100));
  
  // Determine color based on value
  let colorClass = "bg-secondary";
  if (percentage > 90) {
    colorClass = "bg-danger";
  } else if (percentage > 70) {
    colorClass = "bg-warning";
  }

  return (
    <div className={cn("flex items-center", className)}>
      <div className="w-16 bg-gray-200 rounded-full h-2.5 mr-2">
        <div
          className={cn(colorClass, "h-2.5 rounded-full")}
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
      {showLabel && <span className="text-sm text-gray-500">{percentage.toFixed(0)}%</span>}
    </div>
  );
}
